/**
 * Official integration for Smart Search & Instant Search by Searchanise
 * https://apps.shopify.com/searchanise
 *
 * Supported features
 * * Hide products when a filter is applied on collection pages
 * * Hide products from search result.
 */
class WLMHideSearchanise {
    constructor() {
        this.mode = "filter";
        this.superscriptDecimals = false;

        // add observer 
        this.observeHead();

        // add event to remove products form searchanise search popup
        document.addEventListener("keyup", (event) => {
            if (
                event.target === document.querySelector(window.Searchanise.SearchInput)
            ) {
                setTimeout(() => {
                    this.getProductListFromSearch().then((products) => {
                        this.checkIsProductHide(products);
                    });
                }, 100);
            }
        });

    }

    // remove html 
    RemoveHideProducts() {
        //hideShowLoader(false);

        const products = this.getProductEls();

        products.forEach((productLiEl) => {
            const productNameAnchorEl = productLiEl.querySelector("a");
            const handle = this.getHandleFromProductUrl(productNameAnchorEl.href);

            var isHide = this.customFind(window.wlm_local_data.hideProductPayload.products, function (LocalProduct) {
                return handle == LocalProduct.handle;
            });

            if (isHide == undefined) {

                productLiEl.remove();

            }

        });
    }

    // Add products to the window object to save request and for later use
    saveWLMHideProductLocally(json) {
        if (!window.wlm_local_data.hideProductPayload) {
            window.wlm_local_data.hideProductPayload = json;
        } else if (json.products.length) {
            // need to be create unique array
            window.wlm_local_data.hideProductPayload.products = [].concat(
                window.wlm_local_data.hideProductPayload.products,
                json.products
            );

        }

    }

    // Custom function that work as arrow find jQuery function
    customFind(arr, callback) {
        for (var i = 0; i < arr.length; i++) {
            var match = callback(arr[i]);
            if (match) {
                return arr[i];
                break;
            }
        }
    }

    // Hide loader
    hideShowLoader(loader) {
        if (loader) {
            document.getElementById('wlm-loader-container').style.display = "block";
        } else {
            document.getElementById('wlm-loader-container').style.display = "none";
        }
    }

    // Made request to wlm api and call hide products function
    checkIsProductHide(handles = []) {
        var _this = this;
        if (!handles) {
            //hideShowLoader(false);
            return;
        }
        if (handles.length == 0 && window.wlm_local_data.hideProductPayload == undefined) {
            //hideShowLoader(false);
            return;
        }
        const filteredHandles = handles.filter((handle) => {
            if (!window.wlm_local_data.hideProductPayload) {
                return true;
            }

            if (!handle) {
                return false;
            }

            let checkHandle = this.customFind(window.wlm_local_data.hideProductPayload.products, function (product) {
                return product.handle == handle;
            });

            if (checkHandle == undefined) {
                return true;
            } else {
                return false;
            }
        });

        if (filteredHandles.length === 0) {
            this.RemoveHideProducts();
            return Promise.resolve();
        }


        const maxHandleLimit = 20;
        let from = 0;
        let left = filteredHandles.length;
        let to = maxHandleLimit;

        do {
            let paged = filteredHandles.slice(from, to);
            const url = `/search?view=wlm-api&handle=${paged.join(",")}`;
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function () {
                if (this.readyState == 4 && this.status == 200) {
                    var json = JSON.parse(this.responseText);
                    _this.saveWLMHideProductLocally(json);
                }
            }
            xhttp.open("GET", url, false);
            xhttp.send();

            from = to;
            to += maxHandleLimit;
            left -= maxHandleLimit;
        } while (left >= 0);
        this.RemoveHideProducts();
    }

    // Get html container of search results
    getResultContainer() {
        let containerEl = null;
        try {
            containerEl = document.querySelector(
                window.Searchanise.userOptions.ResultsDiv
            );
        } catch (e) { }

        return containerEl;
    }


    // observer
    observeHead() {
        const head = document.querySelector("head");

        const observer = new MutationObserver((mutations) => {
            const removedNodes = mutations[0].removedNodes;
            if (!removedNodes.length) {
                return;
            }
            if (removedNodes[0].src == undefined && window.wlm_local_data.hideProductPayload != undefined) {
                this.checkIsProductHide();
                return;
            }
            const src = removedNodes[0].src;
            if (src == undefined) { return; }
            if (src.match(/searchserverapi\.com\/getresults/)) {
                this.mode = "filter";
                this.getProductList().then((products) => {
                    this.checkIsProductHide(products);
                });
            } else if (src.match(/searchserverapi\.com\/getwidgets/)) {
                this.mode = "search";
                this.getProductListFromSearch().then((products) => {
                    this.checkIsProductHide(products);
                });
            }
        });

        observer.observe(head, {
            subtree: true,
            childList: true,
        });
    }

    // Html Product container
    getProductContainer() {
        let selector;

        if (this.mode === "search") {
            selector = ".snize-ac-results";
        } else if (window.Searchanise.userOptions.ResultsDiv) {
            selector = window.Searchanise.userOptions.ResultsDiv;
        } else {
            selector = "#snize_results";
        }

        return document.querySelector(selector);
    }

    getProductSelector() {
        return ".snize-product";
    }

    // Get html of all products
    getProductEls() {
        const container = this.getProductContainer();
        const selector = this.getProductSelector();

        if (container && selector) {
            return container.querySelectorAll(selector);
        }

        return [];
    }

    // Get products handle
    async getProductList() {
        const productList = [];
        const containerEl = this.getResultContainer();

        if (!containerEl) {
            return;
        }

        const productEls = containerEl.querySelectorAll(".snize-product");

        productEls.forEach((productEl) => {
            const productNameAnchorEl = productEl.querySelector("a.snize-view-link");
            const handle = this.getHandleFromProductUrl(productNameAnchorEl.href);
            productList.push(handle);
        });

        return productList;
    }

    // Get products handle from search
    async getProductListFromSearch() {
        const productList = [];
        const products = this.getProductEls("search");

        for (let productNode of products) {
            const productNameAnchorEl = productNode.querySelector("a");
            const handle = this.getHandleFromProductUrl(productNameAnchorEl.href);
            productList.push(handle);
        }

        return productList;
    }

    // Get product handle from the URL
    getHandleFromProductUrl(url = null) {
        if (url === null) {
            url = this.currentUrl();
        }

        const tempEl = document.createElement("a");
        tempEl.href = url;
        const matches = tempEl.pathname.match("/products/(.*)");
        return matches && matches.length > 1 && matches[1];
    }
   
}
window.wlm_local_data = {}
WLMHideSearchanise = new WLMHideSearchanise();